<template>
  <v-chip-group
    v-model="selectedSector"
    mandatory
    class="solutions-cat-filter-block"
    @update:modelValue="updateSector"
  >
    <v-chip value="all" :ripple="false" label class="solutions-cat-filter-item">
      {{ $t("explorer.sectors.all.name") }}
    </v-chip>
    <v-chip
      v-for="sector in sectorsArray"
      :key="sector.id"
      :value="sector.id"
      :ripple="false"
      label
      class="solutions-cat-filter-item"
      :prepend-icon="`$${sector.icon}`"
    >
      {{ sector.name }}
    </v-chip>
  </v-chip-group>
</template>

<script lang="ts">
export default defineComponent({
  name: "SectorSelectionChips",

  props: {
    initSector: {
      type: String,
      default: "all",
    },
  },

  emits: {
    "update:sector": (id: string) => true,
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    const selectedSector = ref();
    const { sectorsArray } = usePathwaysConfig();

    onBeforeMount(() => {
      selectedSector.value = props.initSector;
    });

    const updateSector = () => {
      if (selectedSector.value !== undefined) {
        emit("update:sector", selectedSector.value);
      }
    };

    return {
      selectedSector,
      sectorsArray,
      updateSector,
    };
  },
});
</script>
<style lang="scss" scoped>
// Filter Styles
// Category Styles
.solutions-cat-filter-block {
  display: flex;
  flex-wrap: wrap;
  margin-top: 80px;
  margin-bottom: 20px;
}
.solutions-cat-filter-item {
  margin-bottom: 25px;
}
.solutions-cat-filter-item:not(:last-child) {
  margin-right: 50px;
}
.solutions-cat-filter-item {
  font-size: 20px;
  font-weight: 500;
  color: #247775;
  text-decoration: none;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 0 5px 0 !important;
  overflow: unset;
  background-color: transparent !important;
  border-bottom: 2px solid transparent;
  border-radius: 0;

  &.v-chip--selected {
    color: #050505;
    border-color: #247775;

    .v-chip__overlay {
      display: none !important;
    }
  }

  :deep(.svg-inline--fa) {
    width: 20px;
    height: 20px;
  }
}

.v-chip--variant-text .v-chip__overlay {
  display: none !important;
  background-color: transparent !important;
  opacity: 0 !important;
  width: 0 !important;
}
</style>
